import { Link } from 'react-router-dom'

const BASE_URL = process.env.PUBLIC_URL

function Thumbnail({ project }) {
  const { slug, title, tagline, kind, badges } = project

  return (
    <Link
      to={`/${slug}`}
      className='thumbnail group flex flex-col h-full bg-white shadow-lg p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-black'
    >
      <div className='h-64 sm:h-72 flex items-center justify-center'>
        <img
          src={`${BASE_URL}/images/${slug}/${slug}.webp`}
          draggable={false}
          loading='lazy'
          className='max-h-full w-full object-contain mx-auto'
          alt={`${title} shown on laptop, tablet, and phone`}
        />
      </div>

      <div className='mt-3'>
        <div className='text-xs uppercase tracking-wide text-gray-400'>{kind}</div>
        <h2 className='mt-1 font-bold group-hover:underline'>{title}</h2>
        <p className='mt-1 text-sm text-gray-600'>{tagline}</p>
        <div className='mt-2'>
          {badges.map((badge) => (
            <span key={badge} className={`badge badge-outline ${badge} badge-sm m-0.5`}>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </Link>
  )
}

export default Thumbnail
